module.exports = __webpack_public_path__ + "static/media/IconTemplates_-20.830cb981.svg";